import r from"styled-components";import{theme as o}from"../../../theme.js";const e=r.div`
  > div {
    display: flex;
    flex-wrap: wrap;
    color: ${o.colors.gray[500]};
    gap: ${o.spacing}px;
    font-size: 14px;
    line-height: 21px;
    > a {
      text-decoration: unset;
      color: ${o.colors.gray[500]};
    }
  }
`;export{e as Container};
